import { InsuranceInfoStage } from './insuranceInfo'
import { RenderStage } from './types'

export const renderStageWithInsuranceInfo: RenderStage = {
  insuranceInfo: InsuranceInfoStage,
}
